import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import React, { forwardRef } from 'react';
import styled from '@xstyled/styled-components';

var _excluded = ["children", "target"];
var _templateObject;
var StyledLink = /*#__PURE__*/styled.a(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: inherit;\n  text-decoration: none;\n"])));
var UniversalLink = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    target = _ref.target,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledLink, _extends({
    color: "inherit",
    ref: ref,
    rel: target === '_blank' ? 'noopener noreferrer' : undefined,
    target: target
  }, rest), children);
});
UniversalLink.displayName = 'UniversalLink';

export { StyledLink, UniversalLink };
